export function fixPrecisionAndFormat(number, precision) {
  const factor = Math.pow(10, precision);
  const fixedNumber = Math.round(number * factor) / factor;
  return parseFloat(fixedNumber.toString());
}